<template>
    <FeatureAnnouncementModal
        v-if="currentAnnouncement"
        :show="showModal"
        :announcement="currentAnnouncement"
        @close="handleClose"
        @dismiss="handleDismiss"
        @dont-show-again="handleDontShowAgain"
    />
</template>

<script>
import FeatureAnnouncementModal from './FeatureAnnouncementModal.vue';

export default {
    name: 'FeatureAnnouncementManager',
    components: {
        FeatureAnnouncementModal,
    },
    data() {
        return {
            announcements: [],
            currentAnnouncement: null,
            showModal: false,
            preferencesLoaded: false,
        };
    },
    computed: {
        isLoading() {
            return this.$store.getters['featureAnnouncements/isLoading'];
        },
    },
    watch: {
        $route() {
            if (this.preferencesLoaded) {
                this.checkForAnnouncements();
            }
        },
    },
    async mounted() {
        await this.loadPreferences();
        this.preferencesLoaded = true;
        this.checkForAnnouncements();
    },
    methods: {
        async loadPreferences() {
            try {
                await this.$store.dispatch('featureAnnouncements/loadPreferences');
            } catch (error) {
                console.warn('Failed to load feature announcement preferences:', error);
            }
        },
        checkForAnnouncements() {
            if (!this.preferencesLoaded || this.isLoading) {
                return;
            }

            try {
                const announcements = this.$store.getters[
                    'featureAnnouncements/getActiveAnnouncements'
                ](this.$route.name);

                const unseenAnnouncements = announcements.filter(
                    (announcement) =>
                        !this.$store.getters['featureAnnouncements/hasSeenAnnouncement'](
                            announcement.id,
                        ) && announcement.showAsModal !== false,
                );

                if (unseenAnnouncements.length > 0) {
                    this.announcements = unseenAnnouncements;
                    this.showNextAnnouncement();
                }
            } catch (error) {
                console.error('Failed to check for announcements:', error);
            }
        },
        showNextAnnouncement() {
            if (this.announcements.length === 0) {
                this.currentAnnouncement = null;
                this.showModal = false;
                return;
            }

            this.currentAnnouncement = this.announcements[0];
            this.showModal = true;
        },
        async handleClose() {
            this.showModal = false;

            if (this.currentAnnouncement) {
                await this.$store.dispatch(
                    'featureAnnouncements/markAsSeen',
                    this.currentAnnouncement.id,
                );
            }
            this.currentAnnouncement = null;
            this.announcements.shift();
            this.$nextTick(() => {
                this.showNextAnnouncement();
            });
        },
        async handleDismiss(announcementId) {
            this.showModal = false;

            if (this.currentAnnouncement) {
                await this.$store.dispatch(
                    'featureAnnouncements/markAsSeen',
                    this.currentAnnouncement.id,
                );
            }
            this.currentAnnouncement = null;
            this.announcements.shift();
            this.$nextTick(() => {
                this.showNextAnnouncement();
            });
        },
        async handleDontShowAgain(announcementId) {
            await this.$store.dispatch('featureAnnouncements/dismissAnnouncement', announcementId);
            this.showModal = false;
            this.currentAnnouncement = null;
            this.announcements.shift();
            this.$nextTick(() => {
                this.showNextAnnouncement();
            });
        },
    },
};
</script>
